import { WebsitesBlockedComponent } from './component/WebsitesBlockedComponent';
import { WEB_COMPONENT_WIDGET_WEBSITES_BLOCKED } from '../webcomponents.constants';

export { WebsitesBlockedComponent };

window.customElements.define(WEB_COMPONENT_WIDGET_WEBSITES_BLOCKED, WebsitesBlockedComponent);
